import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './main/app/App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme/theme';
import './i18n';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  // </React.StrictMode>
);
